// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1dX_r","label":"Category_label__21A6v","content":"Category_content__161de","header":"Category_header__13D48","location":"Category_location__2r0ju"};